import { cn } from "@/utils/cn";
import { memo } from "react";

interface CellGroupProps {
  children: React.ReactNode;
  title?: string;
  showBorder?: boolean;
  classNames?: {
    container?: string;
    title?: string;
    content?: string;
  };
}

export const CellGroup = memo(function CellGroup({
  children,
  title,
  showBorder = true,
  classNames,
}: CellGroupProps) {
  return (
    <div
      className={cn(
        "flex flex-col w-full rounded-[14px] overflow-clip",
        {
          "border border-li-icon": showBorder,
        },
        classNames?.container,
      )}
    >
      {title && (
        <span
          className={cn(
            "text-lg font-bold inline-block my-2",
            classNames?.title,
          )}
        >
          {title}
        </span>
      )}
      <div className={cn("h-full bg-white", classNames?.content)}>
        {children}
      </div>
    </div>
  );
});
